<template>
    <AppTabLinks :links="list" />
</template>

<script>
    import AppTabLinks from '@/components/AppTabLinks'

    export default {
        components: {
            AppTabLinks
        },

        data() {
            return {
                isAuthorized: false,
                list: [
                    {
                        title: 'Логи',
                        url: '/sms-service'
                    },
                    {
                        title: 'Проверка',
                        url: '/sms-service/test'
                    },
                ]
            }
        }
    }
</script>
